import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Input,
  Form,
  FormGroup,
  FormField,
  TextArea,
  Dropdown
} from 'semantic-ui-react'

const ModProgressNoteFormUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="ModProgressNoteFormUX-div-0"
        style={{ width: "100%", height: "100%", padding: "5px" , backgroundColor: "#CCE6F8"}}>
        <div
          id="ModProgressNoteFormUX-div-135"
          style={{display: "flex", justifyContent: "flex-end"}}>
          {props.closeIcon}
        </div>
        <div
          id="ModProgressNoteFormUX-div-2"
          style={{  padding: "15px",  display: "block", marginBottom: "5px" }}>
          <div
            id="ModProgressNoteFormUX-div-145"
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
            
            <div
              id="ModProgressNoteFormUX-div-146"
              style={{ color: "#2362B2", fontWeight: "bold" }}>
              {props.languageUX === "en" ? "Nursing Memo" : "บันทึกข้อความทางการพยาบาล"}
            </div>
            <div
              id="ModProgressNoteFormUX-div-147"
              style={{ ...(props.isOPDEncounter && { display: "none" }) }}>
              
              <Button
                color="yellow"
                id="ModProgressNoteFormUX-Button-148"
                onClick={props.onOpenSelectDoctorOrder}>
                {props.languageUX === "en" ? "Select a doctor's order list" : "เลือกรายการคำสั่งแพทย์"}
              </Button>
            </div>
          </div>
          <div>
            
            <Form>
              <FormGroup
                style={{ display: "flex", alignItems: "center", marginBottom: "15px", ...(props.isOPDEncounter && { display: "none" }) }}>
                <FormField
                  inline={true}
                  width={3}>
                  <div
                    style={{ width: "100%" }}>
                    
                    <label
                      style={{ textAlign: "left", marginRight: "15px",}}>
                      {props.languageUX === "en" ? "Duty" : "เวร"}
                    </label>
                  </div>
                </FormField>
                <FormField
                  inline={true}
                  width={13}>
                  <div
                    style={{ width: "100%" }}>
                    
                    <Input
                      fluid={true}
                      name="working_shift"
                      onChange={props.onChangeData}
                      value={props.selectedNurseNote?.working_shift}>
                    </Input>
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                style={{ display: "flex", alignItems: "center", marginBottom: "15px", ...(props.isOPDEncounter && { display: "none" }) }}>
                <FormField
                  inline={true}
                  width={3}>
                  <div>
                    
                    <label
                      style={{ textAlign: "left", marginRight: "15px",}}>
                      {props.languageUX === "en" ? "Other medical orders" : "คำสั่งแพทย์อื่นๆ"}
                    </label>
                  </div>
                </FormField>
                <FormField
                  inline={true}
                  width={13}>
                  <div>
                    
                    <TextArea
                      name="doctor_order_detail"
                      onChange={props.onChangeData}
                      rows="2"
                      style={{ width:"100%" }}
                      value={props.selectedNurseNote?.doctor_order_detail}>
                    </TextArea>
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                style={{ display: "flex", alignItems: "center", marginBottom: "15px", }}>
                <FormField
                  inline={true}
                  width={3}>
                  <div>
                    
                    <label
                      style={{ textAlign: "left", marginRight: "15px",}}>
                      {props.languageUX === "en" ? "Focus" : "จุดสนใจ"}
                    </label>
                  </div>
                </FormField>
                <FormField
                  inline={true}
                  width={13}>
                  <div
                    className="ui form">
                    
                    <TextArea
                      name="focus"
                      onChange={props.onChangeData}
                      rows="5"
                      style={{ width:"100%", display:"none" }}
                      value={props.selectedNurseNote?.focus}>
                    </TextArea>
                    <Dropdown
                      allowAdditions={true}
                      onAddItem={props.handleAddNurseNoteFocusOptions}
                      onChange={props.onChangeDropdown}
                      options={props.nurseNoteFocusOptions}
                      search={true}
                      selection={true}
                      style={{width:"100%"}}
                      value={props.selectedNurseNote?.focus}>
                    </Dropdown>
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                style={{ display: "flex", alignItems: "flex-start", marginBottom: "15px", }}>
                <FormField
                  inline={true}
                  width={3}>
                  <div
                    style={{ margin: "10px 0px" }}>
                    
                    <label
                      style={{ marginBottom: "10px", whiteSpace: "normal", wordBreak: "break-word" }}>
                      {props.languageUX === "en" ? "Information/Symptoms/Problems" : "ข้อมูล/อาการ/ปัญหา"}
                    </label>
                    <div
                      style={{ textAlign: "left", marginTop: "15px",}}>
                      
                      <label
                        style={{ fontWeight: "bold" }}>
                        {props.languageUX === "en" ? "A" : "ก"}
                      </label>
                      <label>
                        {props.languageUX === "en" ? "ssessment" : "ารประเมิน"}
                      </label>
                    </div>
                  </div>
                </FormField>
                <FormField
                  inline={true}
                  width={13}>
                  <div
                    className="ui form">
                    
                    <TextArea
                      name="diagnosis"
                      onChange={props.onChangeData}
                      rows="8"
                      style={{ width:"100%" }}
                      value={props.selectedNurseNote?.diagnosis}>
                    </TextArea>
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                style={{ display: "flex", alignItems: "flex-start", marginBottom: "15px", }}>
                <FormField
                  inline={true}
                  width={3}>
                  <div
                    style={{ margin: "10px 0px" }}>
                    
                    <label
                      style={{ marginBottom: "10px" }}>
                      {props.languageUX === "en" ? "Nursing" : "การพยาบาล"}
                    </label>
                    <div
                      style={{ textAlign: "left", marginTop: "15px",}}>
                      
                      <label
                        style={ { fontWeight: "bold" }}>
                        {props.languageUX === "en" ? "I" : "ก"}
                      </label>
                      <label>
                        {props.languageUX === "en" ? "ntervention" : "ารแทรกแซง"}
                      </label>
                    </div>
                  </div>
                </FormField>
                <FormField
                  inline={true}
                  width={13}>
                  <div>
                    
                    <TextArea
                      name="plan"
                      onChange={props.onChangeData}
                      rows="10"
                      style={{ width:"100%" }}
                      value={props.selectedNurseNote?.plan}>
                    </TextArea>
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                style={{ display: "flex", alignItems: "flex-start", marginBottom: "15px", }}>
                <FormField
                  inline={true}
                  width={3}>
                  <div
                    style={{ margin: "10px 0px" }}>
                    
                    <label
                      style={{ marginBottom: "10px" }}>
                      {props.languageUX === "en" ? "Nursing outcomes" : "ผลการพยาบาล"}
                    </label>
                    <div
                      style={{ textAlign: "left", marginTop: "15px",}}>
                      
                      <label
                        style={ { fontWeight: "bold" }}>
                        {props.languageUX === "en" ? "E" : "ก"}
                      </label>
                      <label>
                        {props.languageUX === "en" ? "valuation" : "ารประเมินค่า"}
                      </label>
                    </div>
                  </div>
                </FormField>
                <FormField
                  inline={true}
                  width={13}>
                  <div>
                    
                    <TextArea
                      name="goal"
                      onChange={props.onChangeData}
                      rows="8"
                      style={{ width:"100%" }}
                      value={props.selectedNurseNote?.goal}>
                    </TextArea>
                  </div>
                </FormField>
              </FormGroup>
            </Form>
          </div>
          <div
            id="ModProgressNoteFormUX-div-136"
            style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
            
            <div
              id="ModProgressNoteFormUX-div-139"
              style={{padding: "0px 15px", display: "none"}}>
              {props.languageUX === "en" ? "Username" : "ชื่อผู้ใช้"}
            </div>
            <div
              id="ModProgressNoteFormUX-div-140"
              style={{padding: "0px 15px", display: "none"}}>
              
              <Input
                id="ModProgressNoteFormUX-Input-143"
                onChange={props.onChangeUsername}
                placeholder={props.languageUX === "en" ? "Username" : "ชื่อผู้ใช้"}
                value={props.username}>
              </Input>
            </div>
            <div
              id="ModProgressNoteFormUX-div-141"
              style={{padding: "0px 15px", display: "none"}}>
              {props.languageUX === "en" ? "Password" : "รหัสผ่าน"}
            </div>
            <div
              id="ModProgressNoteFormUX-div-142"
              style={{padding: "0px 15px", display: "none"}}>
              
              <Input
                id="ModProgressNoteFormUX-Input-144"
                onChange={props.onChangePassword}
                placeholder={props.languageUX === "en" ? "Password" : "รหัสผ่าน"}
                type="password"
                value={props.password}>
              </Input>
            </div>
            <div
              id="ModProgressNoteFormUX-div-169"
              style={{ ...(!props.selectedNurseNote?.edit_user && { display: "none" }) }}>
              {`ผู้บันทึก/แก้ไข : ${props.selectedNurseNote?.edit_user}`}
            </div>
            <div
              id="ModProgressNoteFormUX-div-137"
              style={{padding: "0px 15px"}}>
              
              <Button
                color="green"
                fluid={true}
                id="ModProgressNoteFormUX-Button-138"
                onClick={props.handleSaveNurseNote}>
                {props.languageUX === "en" ? "record" : "บันทึก"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
}


export default ModProgressNoteFormUX

export const screenPropsDefault = {}

/* Date Time : Wed Sep 24 2025 14:15:24 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", padding: \"5px\" , backgroundColor: \"#CCE6F8\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{  padding: \"15px\",  display: \"block\", marginBottom: \"5px\" }"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.closeIcon"
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-135"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-137"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 15px\"}"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "Button",
      "parent": 137,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-Button-138"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleSaveNurseNote"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ใช้",
          "valueEN": "Username"
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 15px\", display: \"none\"}"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-140"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 15px\", display: \"none\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสผ่าน",
          "valueEN": "Password"
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-141"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 15px\", display: \"none\"}"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-142"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 15px\", display: \"none\"}"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "Input",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-Input-143"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeUsername"
        },
        "placeholder": {
          "type": "value",
          "value": "ชื่อผู้ใช้",
          "valueEN": "Username"
        },
        "value": {
          "type": "code",
          "value": "props.username"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Input",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-Input-144"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePassword"
        },
        "placeholder": {
          "type": "value",
          "value": "รหัสผ่าน",
          "valueEN": "Password"
        },
        "type": {
          "type": "value",
          "value": "password"
        },
        "value": {
          "type": "code",
          "value": "props.password"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-145"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginBottom: \"15px\" }"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกข้อความทางการพยาบาล",
          "valueEN": "Nursing Memo"
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"#2362B2\", fontWeight: \"bold\" }"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-147"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isOPDEncounter && { display: \"none\" }) }"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "Button",
      "parent": 147,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกรายการคำสั่งแพทย์",
          "valueEN": "Select a doctor's order list"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-Button-148"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenSelectDoctorOrder"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "code",
          "value": "`ผู้บันทึก/แก้ไข : ${props.selectedNurseNote?.edit_user}`"
        },
        "id": {
          "type": "value",
          "value": "ModProgressNoteFormUX-div-169"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.selectedNurseNote?.edit_user && { display: \"none\" }) }"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "Form",
      "parent": 178,
      "props": {
      },
      "seq": 179,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "FormGroup",
      "parent": 179,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginBottom: \"15px\", ...(props.isOPDEncounter && { display: \"none\" }) }"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "FormField",
      "parent": 180,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "FormField",
      "parent": 180,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "div",
      "parent": 181,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "Input",
      "parent": 183,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "working_shift"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.selectedNurseNote?.working_shift"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 186,
      "name": "label",
      "parent": 184,
      "props": {
        "children": {
          "type": "value",
          "value": "เวร",
          "valueEN": "Duty"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"left\", marginRight: \"15px\",}"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "FormGroup",
      "parent": 179,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginBottom: \"15px\", ...(props.isOPDEncounter && { display: \"none\" }) }"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "FormField",
      "parent": 187,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 189,
      "name": "FormField",
      "parent": 187,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "div",
      "parent": 189,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "label",
      "parent": 191,
      "props": {
        "children": {
          "type": "value",
          "value": "คำสั่งแพทย์อื่นๆ",
          "valueEN": "Other medical orders"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"left\", marginRight: \"15px\",}"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 193,
      "name": "TextArea",
      "parent": 190,
      "props": {
        "name": {
          "type": "value",
          "value": "doctor_order_detail"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "2"
        },
        "style": {
          "type": "code",
          "value": "{ width:\"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.selectedNurseNote?.doctor_order_detail"
        }
      },
      "seq": 193,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 194,
      "name": "FormGroup",
      "parent": 179,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginBottom: \"15px\", }"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "FormField",
      "parent": 194,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "FormField",
      "parent": 194,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": null,
      "id": 197,
      "name": "div",
      "parent": 195,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": null,
      "id": 198,
      "name": "div",
      "parent": 196,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": null,
      "id": 199,
      "name": "label",
      "parent": 197,
      "props": {
        "children": {
          "type": "value",
          "value": "จุดสนใจ",
          "valueEN": "Focus"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"left\", marginRight: \"15px\",}"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 200,
      "name": "TextArea",
      "parent": 198,
      "props": {
        "name": {
          "type": "value",
          "value": "focus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "5"
        },
        "style": {
          "type": "code",
          "value": "{ width:\"100%\", display:\"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.selectedNurseNote?.focus"
        }
      },
      "seq": 200,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 201,
      "name": "Dropdown",
      "parent": 198,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddNurseNoteFocusOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDropdown"
        },
        "options": {
          "type": "code",
          "value": "props.nurseNoteFocusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedNurseNote?.focus"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 202,
      "name": "FormGroup",
      "parent": 179,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"flex-start\", marginBottom: \"15px\", }"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 203,
      "name": "FormField",
      "parent": 202,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 204,
      "name": "FormField",
      "parent": 202,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": null,
      "id": 205,
      "name": "div",
      "parent": 204,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": null,
      "id": 206,
      "name": "div",
      "parent": 203,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px 0px\" }"
        }
      },
      "seq": 206,
      "void": false
    },
    {
      "from": null,
      "id": 207,
      "name": "div",
      "parent": 206,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"left\", marginTop: \"15px\",}"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": null,
      "id": 208,
      "name": "label",
      "parent": 207,
      "props": {
        "children": {
          "type": "value",
          "value": "ก",
          "valueEN": "A"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": null,
      "id": 209,
      "name": "label",
      "parent": 206,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูล/อาการ/ปัญหา",
          "valueEN": "Information/Symptoms/Problems"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"10px\", whiteSpace: \"normal\", wordBreak: \"break-word\" }"
        }
      },
      "seq": 207,
      "void": false
    },
    {
      "from": null,
      "id": 210,
      "name": "label",
      "parent": 207,
      "props": {
        "children": {
          "type": "value",
          "value": "ารประเมิน",
          "valueEN": "ssessment"
        }
      },
      "seq": 210,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 211,
      "name": "TextArea",
      "parent": 205,
      "props": {
        "name": {
          "type": "value",
          "value": "diagnosis"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "8"
        },
        "style": {
          "type": "code",
          "value": "{ width:\"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.selectedNurseNote?.diagnosis"
        }
      },
      "seq": 211,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 212,
      "name": "FormGroup",
      "parent": 179,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"flex-start\", marginBottom: \"15px\", }"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 213,
      "name": "FormField",
      "parent": 212,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 214,
      "name": "FormField",
      "parent": 212,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "div",
      "parent": 214,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": null,
      "id": 216,
      "name": "div",
      "parent": 213,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px 0px\" }"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": null,
      "id": 217,
      "name": "div",
      "parent": 216,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"left\", marginTop: \"15px\",}"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": null,
      "id": 219,
      "name": "label",
      "parent": 217,
      "props": {
        "children": {
          "type": "value",
          "value": "ก",
          "valueEN": "I"
        },
        "style": {
          "type": "code",
          "value": " { fontWeight: \"bold\" }"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": null,
      "id": 220,
      "name": "label",
      "parent": 217,
      "props": {
        "children": {
          "type": "value",
          "value": "ารแทรกแซง",
          "valueEN": "ntervention"
        }
      },
      "seq": 220,
      "void": false
    },
    {
      "from": null,
      "id": 221,
      "name": "label",
      "parent": 216,
      "props": {
        "children": {
          "type": "value",
          "value": "การพยาบาล",
          "valueEN": "Nursing"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"10px\" }"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 222,
      "name": "TextArea",
      "parent": 215,
      "props": {
        "name": {
          "type": "value",
          "value": "plan"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "10"
        },
        "style": {
          "type": "code",
          "value": "{ width:\"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.selectedNurseNote?.plan"
        }
      },
      "seq": 222,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 223,
      "name": "FormGroup",
      "parent": 179,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"flex-start\", marginBottom: \"15px\", }"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 224,
      "name": "FormField",
      "parent": 223,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 225,
      "name": "FormField",
      "parent": 223,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": null,
      "id": 226,
      "name": "div",
      "parent": 225,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": null,
      "id": 227,
      "name": "div",
      "parent": 224,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px 0px\" }"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": null,
      "id": 228,
      "name": "div",
      "parent": 227,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"left\", marginTop: \"15px\",}"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": null,
      "id": 229,
      "name": "label",
      "parent": 227,
      "props": {
        "children": {
          "type": "value",
          "value": "ผลการพยาบาล",
          "valueEN": "Nursing outcomes"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"10px\" }"
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": null,
      "id": 230,
      "name": "label",
      "parent": 228,
      "props": {
        "children": {
          "type": "value",
          "value": "ก",
          "valueEN": "E"
        },
        "style": {
          "type": "code",
          "value": " { fontWeight: \"bold\" }"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": null,
      "id": 231,
      "name": "label",
      "parent": 228,
      "props": {
        "children": {
          "type": "value",
          "value": "ารประเมินค่า",
          "valueEN": "valuation"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 232,
      "name": "TextArea",
      "parent": 226,
      "props": {
        "name": {
          "type": "value",
          "value": "goal"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "8"
        },
        "style": {
          "type": "code",
          "value": "{ width:\"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.selectedNurseNote?.goal"
        }
      },
      "seq": 232,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 55,
  "isMounted": true,
  "memo": false,
  "name": "ModProgressNoteFormUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 55
}

*********************************************************************************** */
